"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeLanguage = exports.localeCode = exports.locale = void 0;
exports.locale = [
    {
        code: 'ar_AE',
        language: 'Gulf Arabic (United Arab Emirates)'
    },
    {
        code: 'ca_ES',
        language: 'Catalan (Spain)'
    },
    {
        code: 'de_AT',
        language: 'German (Austria)'
    },
    {
        code: 'de_DE',
        language: 'German (Germany)'
    },
    {
        code: 'en_AU',
        language: 'English (Australia)'
    },
    {
        code: 'en_GB',
        language: 'English (UK)'
    },
    {
        code: 'en_IN',
        language: 'English (India)'
    },
    {
        code: 'en_US',
        language: 'English (US)'
    },
    {
        code: 'en_ZA',
        language: 'English (South Africa)'
    },
    {
        code: 'es_419',
        language: 'Spanish (Latin America)'
    },
    {
        code: 'es_ES',
        language: 'Spanish (Spain)'
    },
    {
        code: 'es_US',
        language: 'Spanish (US)'
    },
    {
        code: 'fi_FI',
        language: 'Finnish (Finland)'
    },
    {
        code: 'fr_CA',
        language: 'French (Canada)'
    },
    {
        code: 'fr_FR',
        language: 'French (France)'
    },
    {
        code: 'hi_IN',
        language: 'Hindi (India)'
    },
    {
        code: 'it_IT',
        language: 'Italian (Italy)'
    },
    {
        code: 'ja_JP',
        language: 'Japanese (Japan)'
    },
    {
        code: 'ko_KR',
        language: 'Korean (Korea)'
    },
    {
        code: 'nl_NL',
        language: 'Dutch (The Netherlands)'
    },
    {
        code: 'no_NO',
        language: 'Norwegian (Norway)'
    },
    {
        code: 'pl_PL',
        language: 'Polish (Poland)'
    },
    {
        code: 'pt_BR',
        language: 'Portuguese (Brazil)'
    },
    {
        code: 'pt_PT',
        language: 'Portuguese (Portugal)'
    },
    {
        code: 'sv_SE',
        language: 'Swedish (Sweden)'
    },
    {
        code: 'zh_CN',
        language: 'Mandarin (PRC)'
    },
    {
        code: 'zh_HK',
        language: 'Cantonese (Hong Kong)'
    }
];
_a = exports.locale.reduce((acc, elem) => {
    acc.localeCode.push(elem.code);
    acc.localeLanguage.push(elem.language);
    return acc;
}, { localeCode: [], localeLanguage: [] }), exports.localeCode = _a.localeCode, exports.localeLanguage = _a.localeLanguage;
